<script setup lang="ts">
import plusIcon from '@/assets/icons/plus.svg';

import UiIcon from '@/components/ui/UiIcon.vue';
import UiText from '@/components/ui/UiText.vue';

interface Props {
  title: string;
  description: string;
  underlay?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  underlay: true
});
</script>

<template>
  <button
    class="ui-plus-button"
    :class="{ 'ui-plus-button_underlay': props.underlay }"
    type="button"
  >
    <span class="ui-plus-button__icon-wrapper">
      <UiIcon class="ui-plus-button__icon" :name="plusIcon" :size="24" />
    </span>
    <UiText class="ui-plus-button__title" size="md" weight="semibold">
      {{ props.title }}
    </UiText>
    <UiText class="ui-plus-button__description" size="sm" weight="medium" muted>
      {{ props.description }}
    </UiText>
  </button>
</template>

<style scoped>
.ui-plus-button {
  position: relative;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0 0 0 60px;
  overflow: hidden;
  color: var(--color-main-text);
  font-weight: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  text-align: left;
  background: transparent;
  background-color: var(--color-main-underlay);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  appearance: none;
  user-select: none;
}

.ui-plus-button_underlay {
  padding: 16px 16px 16px 76px;
}

.ui-plus-button__icon-wrapper {
  position: absolute;
  top: calc(50% - 22px);
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  color: var(--color-main-text);
  background-color: var(--color-secondary-contrast);
  border-radius: 50%;
}

.ui-plus-button_underlay .ui-plus-button__icon-wrapper {
  left: 16px;
}

.ui-plus-button__title,
.ui-plus-button__description {
  display: block;
}
</style>
